// src/App.tsx
import React, {useEffect, useState} from 'react';
import { BrowserRouter as Router, Route, Routes, Link, Navigate } from 'react-router-dom';
import { auth } from "./firebaseConfig"
import { onAuthStateChanged } from 'firebase/auth';
import Login from "./screens/Login";
import Home from "./screens/Home";
const App: React.FC = () => {
  const [logged, setlogged] = useState(false);
  const [completed, setcompleted] = useState(false);
  const user = auth.currentUser;
  console.log("APP.TSX")
  useEffect(() => {
    
    // Verifica che Firebase Authentication sia attivo e monitori lo stato di autenticazione
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setcompleted(false)
      setlogged(false)
      if (user) {
        setlogged(true)
        setcompleted(true)
      } else {
        setcompleted(true)
        setlogged(false)
      }
    });

    return () => unsubscribe(); // Cleanup per evitare memory leak
  }, [user]);

  if (completed == false) {
    return null
  }


  return (
    <Router>
      <Routes>
        {user ? (
          // Utente autenticato
          <>
            <Route path="/" element={<Home />} />
            
          </>
        ) : (
          // Utente non autenticato
          <>
            <Route path="/" element={<Login />} />
          </>
        )}
      </Routes>
    </Router>
  );
  
};

export default App;
